var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view"},[_c('van-row',[_c('van-col',{staticClass:"video-title",attrs:{"span":"24"}},[_c('div',[_vm._v("群書只要續篇，敬請期待！")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }